import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  fetchIntraOccupationalReportDetails(_, queryParams = '') {
    return axios.get(`${serverUrl}/reports/intra_occupational_report_detail/${queryParams}`)
  },
  // A and B data
  fetchIntraOccupationalReportDetailsAandBDimensions(_,queryParams='') {
    return axios.get(`${serverUrl}/reports/intra_occupational_report_detail_AandB/custom_total_dimensions/?${queryParams}`)
  },
  fetchIntraOccupationalReportDetailsAandBDominio(_,queryParams='') {
    return axios.get(`${serverUrl}/reports/intra_occupational_report_detail_AandB/custom_total_dominio/?${queryParams}`)
  },
  fetchIntraOccupationalReportDetailsAandBGeneral(_,queryParams='') {
    return axios.get(`${serverUrl}/reports/intra_occupational_report_detail_AandB/custom_total_general/?${queryParams}`)
  },
}